module.exports = __webpack_public_path__ + "static/img/pic1.bb841e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic1.png
// module id = 33
// module chunks = 0